










import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

import { IDnDData } from './';
import { DnDDataChecker } from './DnDDataChecker';
import { DnDDataReader } from './DnDDataReader';

@Component
export default class DnDTarget extends Vue {

    @Prop({ type: String, required: true })
    public acceptedType?: string;
    @Prop({ type: Function, required: false })
    public dragOver?: (evt: DragEvent) => void;
    @Prop({ type: Function, required: false })
    public dragLeave?: (evt: DragEvent) => void;
    @Prop({ type: Function, required: true })
    public dropData?: (data: IDnDData, evt: DragEvent) => void;

    private onDragEnter(evt: DragEvent): void {
        this.dragOverHandler(evt);
    }
    private onDragOver(evt: DragEvent): void {
        this.dragOverHandler(evt);
    }
    private onDragLeave(evt: DragEvent): void {
        if (!evt) { throw new Error('DragEvent is not set'); }

        if (this.dragLeave) {
            this.dragLeave(evt);
        }
    }
    private onDrop(evt: DragEvent): void {
        if (!evt) { throw new Error('DragEvent is not set'); }
        if (!evt.dataTransfer) { throw new Error('dataTransfer property of DragEvent is not set'); }
        if (!this.dropData) { throw new Error('dropData handler is not set'); }

        const dropAccepted = this.isDropAccepted(evt);
        if (dropAccepted) {
            const reader = new DnDDataReader();
            reader.typeName = this.acceptedType;
            reader.read(evt.dataTransfer);

            this.dropData(reader, evt);
        }
    }
    private dragOverHandler(evt: DragEvent): void {
        if (!evt) { throw new Error('DragEvent is not set'); }
        if (!evt.dataTransfer) { throw new Error('dataTransfer property of DragEvent is not set'); }

        const dropAccepted = this.isDropAccepted(evt);
        if (dropAccepted) {
            evt.preventDefault();

            this.$emit('mosaic', evt);

            if (this.dragOver) {
                this.dragOver(evt);
            }
        }
    }
    private isDropAccepted(evt: DragEvent): boolean {
        let result = false;

        if (this.acceptedType && evt.dataTransfer) {
            const checker = new DnDDataChecker();
            checker.typeName = this.acceptedType;
            result = checker.containsType(evt.dataTransfer);
        }

        return result;
    }

}
